/**
 * Lifecycle status of a ProvisionRun (Abrechnungslauf). Ordinal order is NOT the business order:
 * CALCULATION_FAILED/ACTIVATION_FAILED/PAYOUT_FAILED/ABORTED were appended at the end (9-12) but
 * are reachable from earlier business steps. The FE renders the step bar from the explicit business
 * order in provision-run-status-order.ts (CP_RUN_STATUS_ORDER), never from this ordinal order.
 *
 * Position-based mirror of the backend enum {@code com.mvs.backend.cp.enums.ProvisionRunStatus}. The backend
 * persists the ordinal (`@Enumerated(EnumType.ORDINAL)`), so the declaration order below MUST match
 * the backend exactly and new constants MUST only be appended at the end — never inserted between
 * existing ones, which would silently re-map every stored value (02-datenmodell.md §0.5/§2).
 *
 * DOCUMENTED DEVIATION — no `Enum` type-name suffix (befund 10, deliberately NOT changed):
 * `fe_core_standards` requires enum type names to carry an `Enum` suffix. This type, like all 18
 * enums of this module, deliberately omits it, because it is a FROZEN, position-based mirror of a
 * backend enum, not a newly designed FE enum (02-datenmodell.md §0.5/§2). The reference module bm
 * follows the identical convention for its own backend-mirroring enums (e.g.
 * `features/feature-bm/bm/enum/billing-run-status.enum.ts` -> `BillingRunStatus`, no suffix). Per
 * the user's directive to follow the already-implemented, referenced components/modules when a
 * skill rule and the reference module disagree, the name stays `ProvisionRunStatus`.
 */
export enum ProvisionRunStatus {

    NEW,
    IN_CALCULATION,
    CALCULATED,
    IN_REVIEW,
    IN_ACTIVATION,
    ACTIVATED,
    IN_PAYOUT,
    PAID_OUT,
    COMPLETED,
    CALCULATION_FAILED,
    ACTIVATION_FAILED,
    PAYOUT_FAILED,
    ABORTED
}
